module.exports = __webpack_public_path__ + "static/media/jumpseller-configure2.51f358bd.png";